import './SubmitLine.css';
import React, { useContext } from 'react';
import GlobalProps from '../globalProps';
import { ModalContext } from '../Modal/Modal';
import ReactDOM from 'react-dom';

export function SubmitLine({ children }: GlobalProps): JSX.Element {
  const context = useContext(ModalContext);

  const content = (
    <div className="submit-line">
      <div className="submit-line__content">{children}</div>
    </div>
  );
  if (context.footer) {
    return ReactDOM.createPortal(content, context.footer);
  }
  return content;
}
